import { SUBJECT_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const subjectInitialState = {
  data: [],
  subject: {},
  formError: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function subjectReducer(state = subjectInitialState, action) {
  switch (action.type) {
    case SUBJECT_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
